import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';

export interface DialogData {
  content: string;
  title: string;
  isConfirm: boolean;
  confirmCallback: any;
  cancelCallback: any;
}

@Component({
  selector: 'app-notify-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent
  ],
  templateUrl: './notify-dialog.component.html',
  styleUrl: './notify-dialog.component.scss'
})
export class NotifyDialogComponent {
  data = inject(MAT_DIALOG_DATA);
  onCancel(){
    if(this.data.cancelCallback)this.data.cancelCallback();
  }
}
